import { __makeTemplateObject } from '../../../../../../node_modules/tslib/tslib.es6.js';
import styled from 'styled-components';
import { AvatarSizes } from './types.js';

var _a;
var sizes = (_a = {},
    _a[AvatarSizes.SMALL] = 20,
    _a[AvatarSizes.MEDIUM] = 26,
    _a[AvatarSizes.LARGE] = 36,
    _a[AvatarSizes.XLARGE] = 55,
    _a[AvatarSizes.XXLARGE] = 80,
    _a);
var Layout = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n  border-radius: 50%;\n\n  ", "\n"], ["\n  overflow: hidden;\n  border-radius: 50%;\n\n  ", "\n"])), function (_a) {
    var size = _a.size;
    return "\n    width: ".concat(size, "px;\n    min-width: ").concat(size, "px;\n    height: ").concat(size, "px;\n  ");
});
var Image = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"])));
var JazzIcon = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3;

export { Image, JazzIcon, Layout, sizes };
